import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import SiteLayout from "@/components/SiteLayout";

import Home from "@/pages/Home";
import AllServicesPage from "@/pages/AllServicesPage";
import ServicePage from "@/pages/ServicePage";
import LocalSEOPage from "@/pages/LocalSEOPage";
import ReferencesPage from "@/pages/ReferencesPage";
import ContactPage from "@/pages/ContactPage";
import CalculatorPage from "@/pages/CalculatorPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/leistungen" element={<AllServicesPage />} />
              <Route path="/leistungen/:slug" element={<ServicePage />} />
              <Route path="/standort/:slug" element={<LocalSEOPage />} />
              <Route path="/referenzen" element={<ReferencesPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/preisrechner" element={<CalculatorPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}
